import React from "react";
import styled from "styled-components";

function TestimonialVideo() {
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <VideoContainer>
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/YIfW11JZRLk?autoplay=0`}
            title={`testimonial video`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            frameBorder="0"
          />
        </VideoContainer>
        <VideoContainer>
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/YIfW11JZRLk?autoplay=0`}
            title={`testimonial video`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            frameBorder="0"
          />
        </VideoContainer>
        {/* <VideoContainer>
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/PkZNo7MFNFg?autoplay=0`}
            title={`testimonial video`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            frameBorder="0"
          />
        </VideoContainer>
        <VideoContainer>
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/PkZNo7MFNFg?autoplay=0`}
            title={`testimonial video`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            frameBorder="0"
          />
        </VideoContainer> */}
      </div>
    </div>
  );
}

const VideoContainer = styled.div`
  width: 550px;
  height: 350px;
  padding: 24px;
  margin: 12px;
  border-radius: 16px;
  box-shadow: 0px 10px 20px -3px rgba(0, 0, 0, 0.1);

  @media (max-width: 1024px) {
    width: 450px;
  }
`;

export default TestimonialVideo;
